import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { UserMapping } from '../model/usermapping';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalErrorHandler } from '../error-handler/globalErrorHandler';
import { UserMappingService } from '../services/usermapping.service';
import { Roles } from '../common/enums';


@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.css']
})
export class EditUserDialogComponent {

  form: UntypedFormGroup;
  givenName: string;
  surName: string;
  socialSecurityNumber: string;

  name: string;
  loginId: string;
  active: boolean = true;
  airportsValues = ['ARN'];  //Only this for now
  skillsValues = ['AIR','KOOR', 'LAND', 'LKOO'];
  skills: UntypedFormControl;
  permissionValues = ['Inga rättigheter', 'Planners', 'Dispatcher'];

  accessGroupInfo = [{ description: 'Planners', name: Roles.Planner },
    {description: 'Dispatcher', name: Roles.Dispatcher}];

  permissions: UntypedFormControl;
  airports: UntypedFormControl;

  isAdmin: Boolean; //Used for showing Permissions option

  constructor(public dialogRef: MatDialogRef<EditUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public userMapping: UserMapping,
    fb: UntypedFormBuilder,
    private readonly toastr: ToastrService,
    private readonly logger: GlobalErrorHandler,
    private readonly usermappingService: UserMappingService
    ) {

    this.isAdmin = true;
    this.airports = new UntypedFormControl(userMapping.airportsExpanded, Validators.required);
    this.skills = new UntypedFormControl(userMapping.skillsExpanded, Validators.required);
    this.permissions = new UntypedFormControl([]);


    this.form = fb.group({
      active: new UntypedFormControl({ value: this.active, disabled: true } ),
      skills: this.skills,
      airports: this.airports,
      name: new UntypedFormControl( userMapping.name, Validators.required),
      employmentNumber: new UntypedFormControl({ value: userMapping.employmentNumber, disabled: true }),
      loginId: new UntypedFormControl({ value: userMapping.loginID, disabled: true }),
      currentAirportID: new UntypedFormControl(userMapping.currentAirportID, Validators.required),
      changePassword: new UntypedFormControl(),
      permissions: this.permissions

    });
    this.getUserInfo();
  }

  getEnabled() {
    console.log("getEnabled")
    this.usermappingService.getEnabled(this.userMapping.id).then(res => {
      this.form.patchValue({ active: res });
      this.form.controls.active.enable();
    });
  }

  canSave() {
    return this.form.valid && this.form.dirty;
  }

  getUserInfo() {
    console.log("getUserInfo")
    this.usermappingService.getUserInfo(this.userMapping.id).then(res => {

      let memberOf = res.memberOf;
      let memberArray = this.getListOfPermissionByDescription(memberOf).map(p => p.description);
      console.log(`getUserInfo ${res}`, res, memberOf);
      this.form.patchValue({ active: res.accountEnabled as Boolean });
      this.form.controls.active.enable();
      this.form.patchValue({ permissions: memberArray[0]});
    },
      (error) => {
         console.log(error);
      });

  }

  getListOfPermissionByDescription(permissionArray: any) {
    let resultArray = [];
    permissionArray.forEach(p => {
      let r = this.accessGroupInfo.find(agi => agi.description === p);

      if (r === undefined) return;

      resultArray.push(r);
    });
    return resultArray;
  }

  submit() {
    console.log(this.form);

    if (this.form.valid) {

      var userMapping = new UserMapping({});

      userMapping.id = this.userMapping.id;
      userMapping.name = this.form.controls.name.value;
      userMapping.employmentNumber = this.form.controls.employmentNumber.value;

      if (this.form.valid) {

        let pArrayName: any[] = [];
        if (this.permissions.value !== "Inga rättigheter") {
          pArrayName = this.getListOfPermissionByDescription([this.permissions.value]).map(p=> p.name);
        }

        var userData = {
          id: this.userMapping.id,
          name: this.form.controls.name.value,
          active: this.form.controls.active.value,
          currentAirportID: this.form.controls.currentAirportID.value,
          airports: this.airports.value,
          skills: this.skills.value,
          memberOf: pArrayName,
          memberOfChanged: this.permissions.dirty,
          employmentNumber: this.form.controls.employmentNumber.value
        };

        console.log(userData);

        if (
          this.form.controls.name.dirty ||
          this.form.controls.employmentNumber.dirty ||
          this.form.controls.currentAirportID.dirty ||
          this.form.controls.airports.dirty ||
          this.form.controls.skills.dirty ||
          this.form.controls.active.dirty ||
          this.form.controls.permissions.dirty

        ) {
          this.usermappingService.updateUser(userData).then(res => {
            this.toastr.success('Updatering utförd', 'Uppdatering');
          }).catch((res: HttpErrorResponse) => {
            this.toastr.error(res.error, 'Något gick fel när användaren uppdaterades');
          });
        }

        if (this.form.controls.changePassword.dirty) {
          if (this.form.controls.changePassword.value == true) {
            this.usermappingService.resetUserPassword(this.userMapping.id).then(res => {

              this.toastr.success('Lösenordet är nollställt', 'Uppdatering');
            }).catch((err: HttpErrorResponse) => {
              this.toastr.error('Något gick fel när lösenordet nollställdes.', 'Fel');
              this.logger.handleError(err);
            });

          }
        }
        this.dialogRef.close();

      }


    }
  }
}

